import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import getHours from 'date-fns/get_hours';
import getMinutes from 'date-fns/get_minutes';
import setHours from 'date-fns/set_hours';
import setMinutes from 'date-fns/set_minutes';
import format from 'date-fns/format';

import getDateFNSLocale from '../../utils/date/getDateFNSLocale';

import SwipeablePicker, {
  CONTENT_HEIGHT,
  CONTENT_FONT_SIZE,
} from './SwipeablePicker';

import R from 'common/res/R';

function addLeadingZero(num, length = 2) {
  let numAsString = String(num);

  const totalLeadingZero = length - numAsString.length;
  for (let i = 0; i < totalLeadingZero; i++) {
    numAsString = '0' + numAsString;
  }

  return numAsString;
}

class TimePicker extends React.Component {
  static defaultProps = {
    minuteInterval: 5,
  };

  handleChangeHour = hour => {
    const newDate = setHours(this.props.date, Number(hour));

    this.props.onDateChange(newDate);
  };

  handleChangeMinute = minute => {
    const newDate = setMinutes(this.props.date, Number(minute));

    this.props.onDateChange(newDate);
  };

  render() {
    const {
      minuteInterval,
      date: time,
      locale: localeString,
      showDate,
      onClose: handleClose,
    } = this.props;

    const hours = [...Array(24)].map((_, i) => addLeadingZero(i));
    const minutes = [...Array(60 / minuteInterval)].map((_, i) =>
      addLeadingZero(i * minuteInterval)
    );

    const stateHour = getHours(time);
    const stateMinute = getMinutes(time);
    const hourIndex = stateHour >= 24 ? 0 : stateHour;
    const minuteIndex =
      stateMinute >= 60 ? 0 : Math.round(stateMinute / minuteInterval);

    const locale = getDateFNSLocale(localeString);
    const formattedTime = format(time, 'HH:mm', { locale });
    const formattedDate = format(time, 'DD MMMM YYYY', { locale });

    return (
      <View style={styles.container}>
        <View style={styles.header}>
          {Boolean(showDate) && (
            <Text style={styles.headerSublabel}>{formattedDate}</Text>
          )}
          <Text style={styles.headerLabel}>{formattedTime}</Text>
        </View>

        <View style={styles.swiperContainer}>
          <SwipeablePicker
            timeSection={hours}
            index={hourIndex}
            key={`hour-${hourIndex}`}
            onChange={this.handleChangeHour}
          />
          <Text style={styles.timeDivider}>:</Text>
          <SwipeablePicker
            timeSection={minutes}
            index={minuteIndex}
            key={`minute-${minuteIndex}`}
            onChange={this.handleChangeMinute}
          />
        </View>

        <TouchableOpacity onPress={handleClose}>
          <View style={styles.doneButton}>
            <Text style={styles.doneButtonText}>SELESAI</Text>
          </View>
        </TouchableOpacity>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    ...R.elevation.float,
    backgroundColor: R.color.uiLightPrimary,
    borderRadius: 2,
    maxWidth: 256,
    alignSelf: 'center',
  },
  header: {
    borderTopLeftRadius: 2,
    borderTopRightRadius: 2,
    backgroundColor: R.color.brand,
    padding: R.spacing.m,
  },
  headerSublabel: {
    ...R.typography.weightMedium,
    color: R.color.uiLightPrimary,
    fontSize: R.typography.fontSize.small,
    lineHeight: R.typography.fontSize.large,
    opacity: 0.7,
  },
  headerLabel: {
    ...R.typography.weightMedium,
    color: R.color.uiLightPrimary,
    fontSize: R.typography.fontSize.huge,
  },
  swiperContainer: {
    paddingVertical: R.spacing.l,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  timeDivider: {
    ...R.typography.weightMedium,
    fontSize: CONTENT_FONT_SIZE,
    lineHeight: CONTENT_HEIGHT,
  },
  doneButton: {
    ...R.elevation.interactive,
    backgroundColor: R.color.background,
    padding: R.spacing.ml,
    justifyContent: 'center',
    alignItems: 'center',
    borderBottomLeftRadius: 2,
    borderBottomRightRadius: 2,
  },
  doneButtonText: {
    ...R.typography.weightMedium,
    fontSize: R.typography.fontSize.small,
  },
});

export default TimePicker;
